// Sandbox defaults for a freshly selected 'paypal' method.
const paypalDefaults = () => ({
  mode: 'sandbox',
  button_style: 'gold',
  enable_venmo: false,
  enable_credit_card: false,
});

// Settings for a newly selected payment method (fixed DEFECT-29). The settings the
// caller already holds are preserved and the target method's defaults are merged
// over them, so switching method (the form calls this on every change) keeps the
// other method's values — iban / bic / reference_prefix / qr_code_enabled survive a
// switch away from direct_deposit.
export const getDefaultSettings = (
  paymentMethodName: string,
  currentSettings?: Record<string, unknown> | null
): Record<string, unknown> => {
  const preserved = currentSettings ? { ...currentSettings } : {};

  if (paymentMethodName === 'paypal') {
    return { ...preserved, ...paypalDefaults() };
  }

  return preserved;
};

// Shallow-merge one settings key.
export const updateSettings = (
  settings: Record<string, unknown> | undefined,
  key: string,
  value: unknown
): Record<string, unknown> => {
  return { ...settings, [key]: value };
};

// Parse a rate input field (fixed DEFECT-29). An empty or non-numeric field is 0,
// never NaN, so the value stays safe on the wire (NaN serialises to null).
export const parseRateInput = (raw: string): number => {
  const parsed = parseFloat(raw);

  return Number.isNaN(parsed) ? 0 : parsed;
};
